import get from 'lodash/get';
import React, { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const useIntercom = () => {
  const [initialized, setInitialized] = useState(false);
  const { user, isLoggedIn } = useSelector((s) => s.user);
  const { account } = useSelector((s) => s.settings);
  const location = useLocation();
  useEffect(() => {
    if (global.IS_SERVER) return;
    if (user.user_username && account && account.account_id) {
      const intercomProps = {
        app_id: window.APP_CONFIG.REACT_APP_INTERCOM_KEY,
        email: user.user_username,
        name: user.user_first_name + ' ' + user.user_last_name,
        user_api_token: user.user_api_token,
        user_date: String(
          Math.round(new Date(user.user_date).getTime() / 1000),
        ),
        account_email: user.account_email,
        account_phone: user.account_phone,
        account_enabled: user.account_enabled === '1',
        is_active: user.account_enabled,
        member_id: user.member_id,
        user_hash: user.user_intercom_hash,
        twilioCount: user.twilio_count,
        exempt_tax_id: account.exempt_tax_id || 0,
        twilio_number: get(account, 'connections.0.conn_address'),
        account_id: user.account_id,
        account_name: user.account_name,
        account_create_date: String(
          Math.round(new Date(account.account_create_date).getTime() / 1000),
        ),
        account_renewal_date: String(
          Math.round(new Date(account.account_renewal_date).getTime() / 1000),
        ),
        people_greater_5: user.counts.contacts > 5,
        contactCount: user.counts.contacts,
        groupCount: user.counts.groups,
      };
      if (!initialized) {
        window.Intercom('boot', intercomProps);
        setInitialized(true);
      }
    }
    if (!isLoggedIn) {
      const intercomProps = {
        app_id: window.APP_CONFIG.REACT_APP_INTERCOM_KEY,
      };
      if (initialized) {
        console.log('shutdown');
        window.Intercom('shutdown');
      }
      window.Intercom('boot', intercomProps);
      setInitialized(false);
    }
  }, [isLoggedIn, account, user]);

  useEffect(() => {
    if (global.IS_SERVER) return;
    if (isLoggedIn) {
      window.Intercom('update', {
        app_id: window.APP_CONFIG.REACT_APP_INTERCOM_KEY,
        email: user.user_username,
        user_hash: user.user_intercom_hash,
        last_request_at: parseInt(new Date().getTime() / 1000),
      });
    }
  }, [location, isLoggedIn]);
};

export default useIntercom;
